import { render, staticRenderFns } from "./OrganizationTable.vue?vue&type=template&id=766ea1c5"
import script from "./OrganizationTable.vue?vue&type=script&lang=ts"
export * from "./OrganizationTable.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationTable.vue?vue&type=style&index=0&id=766ea1c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports